module.exports = __webpack_public_path__ + "static/media/support.0d939726.svg";